'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'calculator';
var width = 384;
var height = 512;
var aliases = [128425];
var unicode = 'f1ec';
var svgPathData = 'M192 344c13.26 0 24-10.75 24-24S205.3 296 192 296S168 306.7 168 320S178.7 344 192 344zM192 256c13.26 0 24-10.75 24-24S205.3 208 192 208S168 218.7 168 232S178.7 256 192 256zM280 344c13.26 0 24-10.75 24-24s-10.74-24-24-24S256 306.7 256 320S266.7 344 280 344zM280 256c13.26 0 24-10.75 24-24S293.3 208 280 208S256 218.7 256 232S266.7 256 280 256zM280 432c13.26 0 24-10.75 24-24S293.3 384 280 384S256 394.7 256 408S266.7 432 280 432zM104 432h80c13.26 0 24-10.75 24-24S197.3 384 184 384h-80c-13.26 0-24 10.75-24 24S90.74 432 104 432zM320 0H64C28.65 0 0 28.65 0 64v384c0 35.35 28.65 64 64 64h256c35.35 0 64-28.65 64-64V64C384 28.65 355.3 0 320 0zM336 448c0 8.836-7.164 16-16 16H64c-8.836 0-16-7.164-16-16V176h288V448zM336 128h-288V64c0-8.838 7.164-16 16-16h256c8.836 0 16 7.162 16 16V128zM104 256C117.3 256 128 245.3 128 232S117.3 208 104 208S80 218.7 80 232S90.74 256 104 256zM104 344C117.3 344 128 333.3 128 320S117.3 296 104 296S80 306.7 80 320S90.74 344 104 344z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCalculator = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;